// src/redux/tenantSlice.js
import { createSlice } from '@reduxjs/toolkit';
import { applyTenantTheme } from '../services/themeService.ts';

// Initial state for tenant data
const initialState = {
  tenant: {
    name: '',
    assets: {
      logo: '',
      bg: '',
      logoAr: '',
      logoFr: ''
    },
    userFormFields: [],
    obligatoryUserFields: [],
    consumerFormFields: [],
    obligatoryConsumerFields: [],
    merchantSubscriptionFields: [],
    merchantFormFields: [],
    obligatoryMerchantSubscriptionFields: [],
    lotteryFormFields: [],
    obligatoryLotteryFormFields: [],
    merchantTypes: [],
    enabledModules: {
      consumerModule: false,
      merchantModule: false,
      tipsModule: false,
      // Barcode camera scanner. Defaults to false so tenants whose config does
      // not send this key keep the plain 6-digit entry; setTenantData merges the
      // API payload over these defaults, so adding "scannerModule": true in the
      // tenant config is all that is needed to switch a tenant over.
      
    },
    socialMedia:{},
  },
};

export const loadTenantAsset = (tenantName, asset) => {
  try {
    return require(`../assets/tenants/${tenantName}/${asset}.webp`);
  } catch {
    return null;
  }
};

// export const loadTenantGCU = (tenantName, lang) =>{
//   try {
//     return require(`../conditions/${tenantName}/CGU_${lang}.pdf`);
//   }
//   catch {
//     return null;
//   }
// }



// Create the tenant slice
const tenantSlice = createSlice({
  name: 'tenant',
  initialState,
  reducers: {
    // Action to set tenant's name
    setTenantName: (state, action) => {
      state.tenant.name = action.payload;
    },
    // Action to set user form fields
    setUserFormFields: (state, action) => {
      state.tenant.userFormFields = action.payload;
    },
    // Action to set obligatory user fields
    setObligatoryUserFields: (state, action) => {
      state.tenant.obligatoryUserFields = action.payload;
    },
    // Action to set consumer form fields
    setMerchantFormFields: (state, action) => {
      state.tenant.merchantFormFields = action.payload;
    },
    // Action to set obligatory consumer fields
    setObligatoryMerchantFields: (state, action) => {
      state.tenant.obligatoryMerchantFields = action.payload;
    },
    // Action to toggle enabled modules
    toggleModule: (state, action) => {
      const { module, value } = action.payload; // Example: { module: 'consumerModule', value: true }
      if (state.tenant.enabledModules.hasOwnProperty(module)) {
        state.tenant.enabledModules[module] = value;
      }
    },
    // Action to set multiple tenant properties
    setTenantData: (state, action) => {
      const { name, languages, userFormFields, obligatoryUserFields, merchantFormFields,
        obligatoryMerchantFields, merchantSubscriptionFields, merchantTypes,lotteryFormFields, obligatoryLotteryFormFields,
        obligatoryMerchantSubscriptionFields, enabledModules, socialMedia } = action.payload;

      state.tenant.name = name || '';

      console.log("Setting logo path for:", name); // Debugging
      if (name) {
        // state.tenant.assets.logo = `/user/tenants/${name}/logo.png`;
        // state.tenant.assets.bg = `/user/tenants/${name}/bg.png`;
        // state.tenant.assets.logo = loadTenantAsset(name, 'logo');
        // state.tenant.assets.bg = loadTenantAsset(name, 'bg');
        const logo = loadTenantAsset(name, 'logo');
        const bg = loadTenantAsset(name, 'bg');

        state.tenant.assets.logo = logo;
        state.tenant.assets.bg = bg;

        const logoAr = loadTenantAsset(name, 'logoAr');
        const logoFr = loadTenantAsset(name, 'logoFr');

        state.tenant.assets.logoAr = logoAr;
        state.tenant.assets.logoFr = logoFr;
      } else {
        // state.tenant.assets.logo = `/user/tenants/base/logo.png`; // Fallback
        // state.tenant.assets.bg = `/user/tenants/base/bg.png`; // Fallback
        state.tenant.assets.logo = loadTenantAsset('default', 'logo');
        state.tenant.assets.bg = loadTenantAsset('default', 'bg');
      }

      if (name !== undefined) state.tenant.name = name;
      if (languages !== undefined) state.tenant.languages = languages;
      if (userFormFields !== undefined) state.tenant.userFormFields = userFormFields;
      if (obligatoryUserFields !== undefined) state.tenant.obligatoryUserFields = obligatoryUserFields;
      if (merchantFormFields !== undefined) state.tenant.merchantFormFields = merchantFormFields;
      if (obligatoryMerchantFields !== undefined) state.tenant.obligatoryMerchantFields = obligatoryMerchantFields;
      if (merchantSubscriptionFields !== undefined) state.tenant.merchantSubscriptionFields = merchantSubscriptionFields;
      if (merchantTypes !== undefined) state.tenant.merchantTypes = merchantTypes;
      if (obligatoryMerchantSubscriptionFields !== undefined) state.tenant.obligatoryMerchantSubscriptionFields = obligatoryMerchantSubscriptionFields;
      if (lotteryFormFields!== undefined) state.tenant.lotteryFormFields= lotteryFormFields;
      if (obligatoryLotteryFormFields !== undefined) state.tenant.obligatoryLotteryFormFields= obligatoryLotteryFormFields
      if (enabledModules !== undefined) state.tenant.enabledModules = { ...state.tenant.enabledModules, ...enabledModules };
      if (socialMedia !== undefined) state.tenant.socialMedia = socialMedia;
      applyTenantTheme(name); // Apply the tenant theme
    },
  },
});

// Export actions
export const {
  setTenantName,
  setUserFormFields,
  setObligatoryUserFields,
  setConsumerFormFields,
  setObligatoryConsumerFields,
  toggleModule,
  setTenantData,
} = tenantSlice.actions;

// Export the reducer
export default tenantSlice.reducer;
